import useTheme from '@/theme/useTheme';
// import SettingBox from '@/components/features/casino/game-settings';
import dynamic from 'next/dynamic';
import {
  LuckPotMenuWrapper,
  RushWrapper,
  SpinWrapper,
  LuckPotMenuWrapperTablet,
  RushGameBox,
  RushContent,
  RushGameBoxCore,
} from '@/components/features/casino/rush/styles';

const PrizePool = dynamic(() => import('./PrizePool'), {
  ssr: false,
});

// import GameHistory from './GameHistory';
const GameHistory = dynamic(() => import('./GameHistory'), {
  ssr: false,
});
import RushStateInfo from './RushStateInfo';

const BetBtn = dynamic(() => import('./BetBtn'), {
  ssr: false,
});
const InviteBtn = dynamic(() => import('./InviteBtn'), {
  ssr: false,
});
import BlinkingOnlinePlayers from './WinningBroadcast';
import {
  useIsMobileAndUpLg,
  useLuckyPotSize,
  useIsMobileDownLgAndUpMd,
  useRushStyles,
  useSetRushBoxBreakpoint,
  useDownMd,
} from './hooks';

import { useSetAtom, useAtomValue } from 'jotai';
import BgSoundManage from './BgSoundManage';
import UseRushWebSocketSubscribe from './hooks/useRushWebSocketSubscribe';
import RushGameInfo from './RushGameInfo';
import MobileBlinkingOnlinePlayers from '@/components/features/casino/rush/WinningBroadcast/MobileBlinkingOnlinePlayers';

const GameRecommended = dynamic(
  () => import('@/components/features/common/GameRecommended'),
  {
    ssr: false,
  },
);
import RushCelebration from '@/components/features/casino/rush/RushCelebration';
import { WinListSkeleton } from '@/components/features/casino/rush/UserRewardHistory/style';
import { PlayerBoxSkeleton } from '@/components/features/casino/rush/RushPlayerBox/styles';
import { WheelSkeleton } from '@/components/features/casino/rush/Wheel/style';
import RushProgress from '@/components/features/casino/rush/RushProgress';
import { appSidebarOpenState } from '@/state/globalSettings';
// import Wheel from './Wheel';
// import RushPlayerBox from './RushPlayerBox';

const SettingBox = dynamic(
  () => import('@/components/features/casino/game-settings'),
  {
    ssr: false,
  },
);
const UserRewardHistory = dynamic(() => import('./UserRewardHistory'), {
  loading: () => <WinListSkeleton variant="rectangular" animation="wave" />,
  ssr: false,
});

const RushPlayerBox = dynamic(() => import('./RushPlayerBox'), {
  ssr: false,
  loading: () => <PlayerBoxSkeleton variant="rectangular" animation="wave" />,
});

const Wheel = dynamic(() => import('./Wheel'), {
  ssr: false,
  loading: () => <WheelSkeleton variant="circular" animation="wave" />,
});

const RushMenus = () => {
  const isMobileDownLgAndUpMd = useIsMobileDownLgAndUpMd();
  const isMobileAndUpLg = useIsMobileAndUpLg();
  const downMd = useDownMd();
  // 当页面缩小时，menu宽度会过大，所以需要scale一下
  const menuStyles = () => {
    return isMobileAndUpLg
      ? {
          transform: 'scale(0.8)',
          bottom: 0,
        }
      : {};
  };
  const { theme } = useTheme();
  // downMd时，判断侧边栏有没有打开
  const appSidebarOpen = useAtomValue(appSidebarOpenState);
  const spinStyle =
    downMd && appSidebarOpen
      ? {
          [theme.breakpoints.down('md')]: {
            width: `calc(100% - 240px)`,
          },
          [theme.breakpoints.down('sm')]: {
            width: `100%`,
          },
        }
      : {};
  return isMobileDownLgAndUpMd ? (
    <LuckPotMenuWrapperTablet className={'rush-menus-tablet'}>
      {/*<RushStateInfo />*/}
      <RushCelebration />
      <SpinWrapper sx={spinStyle}>
        <BetBtn />
        <InviteBtn />
        {/*<ReferralBonus />*/}
      </SpinWrapper>
    </LuckPotMenuWrapperTablet>
  ) : (
    // pc and mobile
    <>
      <LuckPotMenuWrapper sx={menuStyles} className={'rush-menus'}>
        {/*celebration is only shown at the end of the game*/}
        <RushCelebration />
        <RushStateInfo />
        <SpinWrapper className={'spin-wrapper'} sx={spinStyle}>
          <BetBtn />
          {!downMd && <InviteBtn />}
          {/*<ReferralBonus />*/}
        </SpinWrapper>
      </LuckPotMenuWrapper>
    </>
  );
};

export default function Rush() {
  const { isMobile, isDesktop, isTablet } = useLuckyPotSize();

  const { ref } = useSetRushBoxBreakpoint();

  const { rushGameBoxStyle } = useRushStyles();
  return (
    <>
      <UseRushWebSocketSubscribe />
      <RushWrapper id={'lucky-pot-wrapper'}>
        <PrizePool />
        <RushProgress />
        <RushContent>
          <RushGameBox
            ref={ref}
            sx={rushGameBoxStyle}
            className={'rush-game-box'}
          >
            <GameHistory />
            {isDesktop && <BlinkingOnlinePlayers />}
            <RushGameBoxCore className={'rush-game-box-bottom'}>
              <Wheel />
              <RushMenus />
            </RushGameBoxCore>
          </RushGameBox>
          <RushPlayerBox />
          <UserRewardHistory />
        </RushContent>

        {isMobile && <MobileBlinkingOnlinePlayers />}
      </RushWrapper>
      <SettingBox
        isMob={isMobile}
        gameId={'rush'}
        fairnessLink={'/casino/fairness-rush'}
      ></SettingBox>
      <RushGameInfo />
      <GameRecommended />
      <BgSoundManage />
    </>
  );
}
